const pubsub = require("pubsub-js");
const clevertap = require("clevertap-web-sdk");
const { initialization } = require("./src/initialization/index");
const { getPushEventData } = require("./src/utils/prepareData");
const { pushProfile } = require("./src/utils/pushEvent");

initialization();

function analysisPublish(payload) {
  try {
    const { product = "", event = "" } = payload;
    const preparedData = getPushEventData(payload);

    if (event === "PushProfile") {
      pushProfile(product, payload);
    } else {
      pubsub.publish(product, preparedData);
    }
  } catch (error) {
    console.error(error);
  }
}

module.exports = { analysisPublish, clevertap };
